// Module
var code = "<p class=\"text__title bold\"></p> <i class=\"text__paragraph p7\"></i> ";
// Exports
export default code;